import { effect, signal } from "@preact/signals-react";
import { getShareableSetting, setShareableSetting, } from "../shared/services/transforms";
import { computeForecastBounds, isDateWithinForecastRange, } from "../utils/forecastDateUtils";
const KEY = "selectedForecastDate";
const MAX_AGE_DAYS = 30;
const getTodayDateString = () => {
    return new Date().toISOString().split("T")[0] ?? "";
};
const isValidRecentDate = (dateString) => {
    if (dateString === null || dateString === "")
        return false;
    try {
        const savedDate = new Date(dateString + "T00:00:00");
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        savedDate.setHours(0, 0, 0, 0);
        if (isNaN(savedDate.getTime())) {
            return false;
        }
        const diffTime = today.getTime() - savedDate.getTime();
        const diffDays = diffTime / (1000 * 60 * 60 * 24);
        const isValid = diffDays <= MAX_AGE_DAYS;
        return isValid;
    }
    catch (error) {
        console.error("Error validating date %o: %o", dateString, error);
        return false;
    }
};
const getInitialDate = () => {
    const savedDate = getShareableSetting(KEY);
    if (savedDate !== null &&
        isValidRecentDate(savedDate) &&
        isDateWithinForecastRange(savedDate)) {
        return savedDate;
    }
    let today = getTodayDateString();
    if (!isDateWithinForecastRange(today)) {
        const { minDate, maxDate } = computeForecastBounds();
        if (today < minDate) {
            today = minDate;
        }
        else if (today > maxDate) {
            today = maxDate;
        }
    }
    if (today !== "") {
        setShareableSetting(KEY, today);
    }
    return today;
};
export const selectedForecastDate$ = signal(getInitialDate());
let isInitialLoad = true;
effect(() => {
    const value = selectedForecastDate$.value;
    if (isInitialLoad) {
        isInitialLoad = false;
        return;
    }
    if (value !== undefined && value !== "") {
        setShareableSetting(KEY, value);
    }
});
//# sourceMappingURL=forecastDate.js.map